/* eslint-disable */
import { useSeoFetch } from '@/hooks/useSeoFetch';
import seoAhrefsService from '@/services/seoAhrefs';

export function useBacklinkProfile(projectId: string | undefined) {
  const {
    data: latestSnapshot,
    isLoading: isLoadingSnapshot,
    refetch: refetchSnapshot,
  } = useSeoFetch(
    ['ahrefs-domain-snapshot', projectId],
    () => seoAhrefsService.getLatestDomainSnapshot(projectId!),
    { enabled: !!projectId }
  );

  const { data: domainHistory = [], isLoading: isLoadingHistory } = useSeoFetch(
    ['ahrefs-domain-history', projectId],
    () => seoAhrefsService.getDomainSnapshots(projectId!, 90),
    { enabled: !!projectId }
  );

  const { data: newBacklinks = [], isLoading: isLoadingNew } = useSeoFetch(
    ['ahrefs-new-backlinks', projectId],
    () => seoAhrefsService.getNewBacklinks(projectId!, 7),
    { enabled: !!projectId }
  );

  const { data: lostBacklinks = [], isLoading: isLoadingLost } = useSeoFetch(
    ['ahrefs-lost-backlinks', projectId],
    () => seoAhrefsService.getLostBacklinks(projectId!, 7),
    { enabled: !!projectId }
  );

  return {
    latestSnapshot,
    domainHistory,
    newBacklinks,
    lostBacklinks,
    isLoading: isLoadingSnapshot || isLoadingHistory || isLoadingNew || isLoadingLost,
    refetchSnapshot,
  };
}
